// @flow
import * as React from 'react';

import Link from 'app/common/lib/link';
import { DotsLoader } from 'app/common/components/Loader';

import styles from './CatalogSection.module.scss';;


type Props = {
  title: string,
  imgSrc?: string,
  link: string,
  loading?: boolean,
}

const CatalogSection = ({ title, imgSrc, link, loading }: Props) => (
  <div className={styles.root}>
    <div className={styles.image}>
      <Link to={link}>
        <img src={imgSrc} alt={title} />
      </Link>
    </div>
    <div className={styles.title}>
      <Link to={link} className={styles.link}>
        {title}
      </Link>
    </div>
    {loading && <div className={styles.loaderContainer}>
      <DotsLoader className={styles.loader} />
    </div>}
  </div>
);

export default CatalogSection;
